var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 18.6687C22.0391 18.6687 20.8662 19.1977 20.02 20.0502L12.7898 15.8747C12.9671 15.2804 13.0667 14.6518 13.0667 14.0016C13.0667 13.3917 12.9764 12.8036 12.8209 12.2436L18.1067 9.19124C19.1333 10.4203 20.6733 11.2012 22.4 11.2012C25.4924 11.2012 28 8.69341 28 5.60062C28 2.50783 25.4924 0 22.4 0C19.3076 0 16.8 2.50783 16.8 5.60062C16.8 5.96155 16.8373 6.31315 16.9027 6.65229L11.5049 9.76997C10.3071 8.3636 8.52445 7.4675 6.53333 7.4675C2.92444 7.4675 0 10.3923 0 14.0016C0 17.6108 2.92444 20.5356 6.53333 20.5356C8.484 20.5356 10.2293 19.6769 11.4271 18.3203L18.7476 22.5456C18.704 22.8039 18.6667 23.0621 18.6667 23.3328C18.6667 25.9091 20.7573 28 23.3333 28C25.9093 28 28 25.9091 28 23.3328C28 20.7565 25.9093 18.6687 23.3333 18.6687ZM22.4 2.80031C23.9462 2.80031 25.2 4.05423 25.2 5.60062C25.2 7.14702 23.9462 8.40093 22.4 8.40093C20.8538 8.40093 19.6 7.14702 19.6 5.60062C19.6 4.05423 20.8538 2.80031 22.4 2.80031ZM6.53333 17.7353C4.47067 17.7353 2.8 16.0645 2.8 14.0016C2.8 11.9387 4.47067 10.2678 6.53333 10.2678C8.596 10.2678 10.2667 11.9387 10.2667 14.0016C10.2667 16.0645 8.596 17.7353 6.53333 17.7353ZM23.3333 25.2028C22.3036 25.2028 21.4667 24.3658 21.4667 23.3359C21.4667 22.306 22.3036 21.4691 23.3333 21.4691C24.3631 21.4691 25.2 22.306 25.2 23.3359C25.2 24.3658 24.3631 25.2028 23.3333 25.2028Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.57d9bc90f1f4a7a00d319a2491f0f7e5.svg";
export { ForwardRef as ReactComponent };